<template>
    <div>
        <div key="loading" class="flex justify-center" v-if="loading">
            <div class="aspect-[320/480] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div v-else class="flex flex-col mt-md">
            <div class="grid gap-y-lg xs:gap-md grid-cols-12">
                <div v-for="item in mainRecipes" :key="item.item.slug" class="col-span-12 xs:col-span-4">
                    <recipeitem :content="item.item" :tags="item.tags" />
                </div>
            </div>
            <template v-if="sideRecipes.length">
                <span class="font-semibold mt-lg mb-sm text-primary-400 inline-flex items-center gap-xs xl:pointer-events-none">Tussendoortjes & desserts</span>
                <div class="p-md bg-gray-700">
                    <div class="grid gap-y-lg xs:gap-md grid-cols-12">
                        <div v-for="item in sideRecipes" :key="item.item.slug" class="col-span-12 lg:col-span-6">
                            <recipesideitem :content="item.item" :tags="item.tags" />
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import recipeitem from './item';
import recipesideitem from './sideitem';

export default {
    name: 'recipeweek',

    components: {
        recipeitem,
        recipesideitem,
    },

    props: ['recipes'],

    data() {
        return {
            recipeObjects: [],
            loading: false,
        };
    },

    mounted() {
        this.getRecipes();
    },

    methods: {
        getRecipes() {
            this.loading = true;

            axios
                .get('/api/my-recipes?slugs=' + this.recipes.map((r) => r.gerecht).join())
                .then((response) => {
                    if (response.status === 200) {
                        let recipes = response.data.data;
                        this.recipeObjects = recipes;
                    } else {
                        this.recipeObjects = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        getTagsForRecipe(recipeSlug) {
            const recipe = this.recipes.find((r) => r.gerecht === recipeSlug);

            const mealTypes = {
                breakfast: 'Ontbijt',
                lunch: 'Lunch',
                dinner: 'Avondmaal',
                extra: 'Tussendoor',
                dessert: 'Dessert',
            };

            return recipe ? [mealTypes[recipe.meal_type]] : null;
        },
    },

    computed: {
        mainRecipes() {
            let mainrecipes = [];

            this.recipeObjects.forEach((obj) => {
                const matchingRecipe = this.recipes.find((r) => r.gerecht === obj.slug);

                if (matchingRecipe && !['extra', 'dessert'].includes(matchingRecipe.meal_type)) {
                    mainrecipes.push({
                        item: obj,
                        tags: this.getTagsForRecipe(obj.slug),
                    });
                }
            });

            mainrecipes.sort((a, b) => {
                if ((a.tags[0] === 'Ontbijt' && (b.tags[0] === 'Lunch' || b.tags[0] === 'Avondmaal')) || (a.tags[0] === 'Lunch' && b.tags[0] === 'Avondmaal')) {
                    return -1;
                }

                if ((a.tags[0] === 'Lunch' && b.tags[0] === 'Ontbijt') || (a.tags[0] === 'Avondmaal' && (b.tags[0] === 'Ontbijt' || b.tags[0] === 'Lunch'))) {
                    return 1;
                }

                return 0;
            });

            return mainrecipes;
        },

        sideRecipes() {
            const siderecipes = [];

            this.recipeObjects.forEach((obj) => {
                const matchingRecipe = this.recipes.find((r) => r.gerecht === obj.slug);

                if (matchingRecipe && ['extra', 'dessert'].includes(matchingRecipe.meal_type)) {
                    siderecipes.push({
                        item: obj,
                        tags: this.getTagsForRecipe(obj.slug),
                    });
                }
            });

            return siderecipes;
        },
    },
};
</script>
